const apiURL   = "https://parcel-intelligence.com/cs/api_ex.php";
const apiKEY   = "06adb90fce2000cbc89ec59b89a0b3161d020af2";

const formatMoney = (quantity)=>{
  let currency = '$';
  if( Number.isInteger(quantity) ){
    return `${currency}${quantity}.00`
  } else {
    return `${currency}${quantity.toString()}`
  }
}

// function addModal(element){
//   console.log(element);
// 	let modalId = element[0].id;
// 	let modalContent = element.find(".modal-content").html();
// 	$("body").prepend(`
// 		<div class="modal-wrap" id="modal-${modalId}">
// 			<div class="modal-container">
// 				<div class="close-modal">x</div>
// 					${modalContent}
// 			</div>
// 			<div class="backdrop"></div>
// 		</div>
// 	`);
// 	let popupModal = $('#modal-'+ modalId +'');
// 	element.click(function(event){
// 		event.preventDefault();
// 		popupModal.addClass("show-modal");
// 		popupModal.find(".modal-container").fadeIn();
// 	});
// 	popupModal.find(".close-modal").click(function(event){
// 		event.preventDefault();
// 		popupModal.removeClass("show-modal");
// 		popupModal.find(".modal-container").hide();

// 	});
// }

// function createRatesList(rates, placeName){
function createRatesList(rates, zipCode){
  let resultsContainer    = $("#shipping_result");
  let formatedPrice = " - <span>FREE</span>";
  let ratesHtmlList = "";
  let infoIcon = '<div class="info-icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><defs><style>.a{fill:#f68d63;}</style></defs><path class="a" d="M92.894,82.573a7.5,7.5,0,1,0-4.6,11.681,7.5,7.5,0,0,0,5.884-6.171,8.05,8.05,0,0,0,.094-1.172V86.9A7.5,7.5,0,0,0,92.894,82.573Zm-7.051-.388a1.22,1.22,0,0,1,1.335-.362,1.235,1.235,0,0,1,.813,1.134v.035a1.219,1.219,0,1,1-2.147-.806Zm2.385,8.232v.853a.264.264,0,0,1-.26.26h-2.39a.264.264,0,0,1-.26-.26V90.4a.264.264,0,0,1,.26-.26h.274V86.61h-.274a.264.264,0,0,1-.26-.26v-.87a.264.264,0,0,1,.26-.26h1.856a.264.264,0,0,1,.26.26v4.659h.274a.263.263,0,0,1,.26.26Z" transform="translate(-79.272 -79.406)"/></svg></div>';
  for (var i = 0; i < rates.length; i++) {
    let price = parseInt(rates[i].total_price);
    if(price > 0){
      formatedPrice = " - " + formatMoney(rates[i].total_price / 100);
    }
    if(rates[i].service_name.indexOf('Quote') >= 1){
      formatedPrice = "";
    }
    ratesHtmlList += `
    <div class="shipping__item">
    ${rates[i].service_name}
    ${formatedPrice}
    </div>
    `;
    let priceHolder = document.querySelector('.hc-dropdown__label p');
    let addressHolder = document.querySelector('#delivery-address');
    console.log(formatedPrice)
    
    if(formatedPrice !== '') {
      if(rates[0].total_price > 0) {
        let price = `$${rates[0].total_price / 100}.00`;
        let vscompAttr = document.querySelector('.vscomp-value').getAttribute('data-tooltip');
        let vscompArray1 = vscompAttr.split('(');
        let vscompArray2 = vscompArray1[0].split('-');
        priceHolder.innerHTML = `Estimated delivery rate <span> ${price} to ${vscompArray2[1]} ${vscompArray2[0]}</span>`;
      } else {
        let vscompAttr = document.querySelector('.vscomp-value').getAttribute('data-tooltip');
        let vscompArray1 = vscompAttr.split('(');
        let vscompArray2 = vscompArray1[0].split('-');
        // priceHolder.innerHTML = `Estimated delivery rate <span> FREE to ${vscompArray2[1]} ${vscompArray2[0]}</span>`;
        priceHolder.innerHTML = `Estimated delivery rate FREE to ${vscompArray2[1]} ${vscompArray2[0]}`;
      }
    } else {
      priceHolder.innerHTML = 'Click here to estimate Shipping';
    }

    // if(formatedPrice == '') {
    //   console.log("NOT DELIVERY")
    //   priceHolder.innerHTML = 'Click here to estimate Shipping';
      
    // } else if (formatedPrice == " - <span>FREE</span>") {
    //   console.log('FREE');
    //   let vscompAttr = document.querySelector('.vscomp-value').getAttribute('data-tooltip');
    //   let vscompArray1 = vscompAttr.split('(');
    //   let vscompArray2 = vscompArray1[0].split('-');
    //   // priceHolder.innerHTML = `Estimated delivery rate <span> FREE to ${vscompArray2[1]} ${vscompArray2[0]}</span>`;
    //   priceHolder.innerHTML = `Estimated delivery rate FREE to ${vscompArray2[1]} ${vscompArray2[0]}`;
    // } else if (formatedPrice !== " - <span>FREE</span>" && formatedPrice !== "") {
    //     console.log("TAX")
    // }
  }
  resultsContainer.find(".shipping_data").html(ratesHtmlList);
  if(!resultsContainer.hasClass("active")){
    resultsContainer.slideToggle("fast").addClass("active");
  }
}

const syncAJAX = (options) => {
  return new Promise((resolve,reject)=>{
    $.ajax(options)
    .done(function(response, __, xhr) {
      resolve({
        'xhr':xhr,
        'body':response
      })
    })
    .fail(function(xhr) {
      reject({
        'xhr':xhr});
    });
  });
}

const calculateZip = (zipCode_handler, quantity_handler, zip_code) => {
  let zipCode = zip_code == undefined ? $(`${zipCode_handler}`).val() : zip_code;
  let variantId = parseInt($(`${zipCode_handler}`).attr("data-variant-id"));
  let quantity = $(`${quantity_handler}`).val();
  let product = JSON.parse($("#product__shipping-product-json").html());
  let customerTag = $(`${zipCode_handler}`).attr("data-customer-tag");
  console.log({
    'zipCode':zipCode,
    '?zipCode': zip_code == undefined,
    'variantId':variantId,
    'quantity':quantity,
    'product':product,
    'customerTag':customerTag
  });
  
  let formData = {
    "origin":{
      "country":"AU",
      "postal_code":"2040",
      "province":"NSW",
      "city":"Sydney",
      "address1":"483 Balmain Road",
      "company_name":"SLH"
    },
    "destination":{
      "postal_code": zipCode,
    },
    "items":[
      {
        "name": product.title,
        "quantity": quantity,
        "product_id": product.id,
        "variant_id": variantId
      }
    ],
    "CUSTOMER_TYPE": customerTag,
    "API_KEY": apiKEY
  };
  let settings = {
    url: apiURL,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "HTTP_X_STORE_NAME": "slh-au.myshopify.com",
      "HTTP_X_STORE_TOKEN": apiKEY
    },
    data: JSON.stringify(formData),
  };
  let ajaxResult;
  syncAJAX(settings).then((data)=>{
    ajaxResult = data;
    if( data.xhr.status == 200 ){
      createRatesList(data.body.rates, zipCode);
    }
    $("#shipping__calculate").removeClass("loading").prop("disabled", false);
  }).catch((err)=>{
    // HANDLE ERROR
  })
}

$(document).ready(function() {  
  $("#shipping__calculate").click(function(event) {
    event.preventDefault();
    let button = $(this);
    button.addClass("loading").prop("disabled", true);
    calculateZip("#zip-select", ".o-quantity-selector__select-field option:selected");
  });
});